module.exports = __webpack_public_path__ + "static/img/jd4.3de640d9.png";